var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        direction: "ltr",
        size: "75%",
        visible: _vm.unfold,
        "with-header": false
      },
      on: {
        "update:visible": function($event) {
          _vm.unfold = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "background-color": "#003333", height: "100%" } },
        [
          _c(
            "el-row",
            { staticStyle: { "border-bottom": "1px solid #cccccc" } },
            [
              _c(
                "el-col",
                { staticClass: "left-centered", attrs: { span: 12 } },
                [
                  _c("img", {
                    staticStyle: { width: "150px", height: "41px" },
                    attrs: {
                      alt: "UNIFI Property",
                      src: require("../../../../assets/unifi-logo-new-with-text-white.svg")
                    },
                    on: { click: _vm.redirectToHome }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row", [
            _c("li", { staticStyle: { "background-color": "#ffffff" } }, [
              _vm.isSignedIn
                ? _c(
                    "ul",
                    {
                      staticClass: "sub-menu-item-style sub-item-font",
                      staticStyle: { "padding-bottom": "26px" },
                      on: { click: _vm.logout }
                    },
                    [_vm._v("\n          Logout\n        ")]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            {
              staticStyle: {
                "background-color": "#003333",
                height: "100%",
                "padding-top": "90px"
              }
            },
            [
              _c(
                "el-col",
                {
                  staticClass: "centered-social-icon",
                  attrs: { sm: 6, span: 6, xs: 6 }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.facebook.com/unifiproperty",
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Facebook",
                          src: require("../../../../assets/facebook48x48.png")
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "centered-social-icon",
                  attrs: { sm: 6, span: 6, xs: 6 }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.instagram.com/unifiproperty/",
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: "Instagram",
                          src: require("../../../../assets/instagram48x48.png")
                        }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2aea500", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2aea500","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/stepsHeaderDrawerAside.vue
// module id = null
// module chunks = 